module.exports = __webpack_public_path__ + "static/media/ic-map.9d3b6617.png";